import { atom } from 'jotai';
import { ColumnState } from 'ag-grid-community';

const rowGroupColumnsBaseAtom = atom<ColumnState[]>([]);

/** Same columns grouped in the same order. Array order is ignored: ag-grid reports grouped columns in display order. */
export function sameRowGroups(a: ColumnState[], b: ColumnState[]): boolean {
  if (a.length !== b.length) {
    return false;
  }
  const indexById = new Map(a.map((col) => [col.colId, col.rowGroupIndex ?? null]));
  return b.every(
    (col) => indexById.has(col.colId) && indexById.get(col.colId) === (col.rowGroupIndex ?? null)
  );
}

// The grid re-announces its grouping after every first render. An unchanged grouping keeps its
// identity here, or every memo keyed on it (the full client-side metrics rebuild) runs again.
export const rowGroupColumnsState = atom(
  (get) => get(rowGroupColumnsBaseAtom),
  (get, set, next: ColumnState[]) => {
    if (!sameRowGroups(get(rowGroupColumnsBaseAtom), next)) {
      set(rowGroupColumnsBaseAtom, next);
    }
  }
);

export const collapsedDealStages = atom<Record<string, boolean>>({});

export const isFirstRenderDonePFJ = atom<boolean>(false);

/** True from a view click in the menu until the new view has committed; the page loader reads it. */
export const isViewSwitchPendingPFJ = atom<boolean>(false);

/**
 * True while the page loads data for the applied as-of date; the header's date picker waits on it.
 * One publisher is mounted at a time (company/transaction or fund page), and each resets it on unmount.
 */
export const isAsOfDateLoadingPFJ = atom<boolean>(false);
